<template>
  <div class="be-alliance-container">
    <div class="content success" v-if="hasBeenAgent">
      <van-empty>
        <img slot="image" class="image" src="./images/success.png">
        <div slot="description">
          <div class="title">您已成为综合服务平台加盟商！</div>
          <div>请联系管理员为您分配相应的权限。</div>
        </div>
      </van-empty>
    </div>
    <div class="content" v-else>
      <van-notice-bar left-icon="volume-o" :scrollable="false" wrapable>
        请填写真实的商户信息，注册成功后不得更改！<br />
      </van-notice-bar>
      <van-cell-group>
        <van-field v-model="inviteCode" v-if="inviteCode" label="邀请码" required readonly />
        <van-field v-model="formValue.partnerName" required clearable label="商户名称" placeholder="如：星火金服" />
        <van-field v-model="formValue.entity" required clearable label="商户主体" placeholder="如：星火信息服务有限公司" />
        <van-field v-model="formValue.owner" required clearable label="负责人姓名" placeholder="请输入负责人姓名" :maxlength="4" />
        <van-field v-model="formValue.phoneNo" required clearable label="负责人手机" placeholder="请填写负责人手机" :maxlength="11" />
        <van-field v-model="formValue.vcode" required clearable label="短信验证码" placeholder="请填写短信验证码" :maxlength="6"
          class="code-field">
          <template #button>
            <van-button style="width: 110px;" size="small" type="primary" @click="onSendCode" :disabled="counting">
              {{ counting ? `重新发送(${countDown}s)` : '发送验证码' }}
            </van-button>
          </template>
        </van-field>
      </van-cell-group>
      <div class="button-container">
        <van-button type="primary" round block :loading="loading" loading-type="spinner" @click="onSubmitForm">
          注册
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { bindAlliance, sendVcode } from '@/services/UserService'
import * as RegExp from '@/constants/regExp'

export default {
  name: 'BeAlliance',
  data() {
    return {
      inviteCode: this.$route.params.inviteCode,
      counting: false,
      countDown: 60,
      loading: false,
      formValue: {
        partnerName: '',
        entity: '',
        owner: '',
        phoneNo: '',
        vcode: ''
      },
      hasBeenAgent: false
    }
  },
  computed: {
    ...mapGetters(['partnerName'])
  },
  mounted() {
    document.title = '加入我们'
  },
  methods: {
    async onSendCode() {
      if (!this.counting) {
        if (!this._validateFormValue('vcode')) {
          return
        }
        const openId = localStorage.getItem('openId')
        const response = await sendVcode({
          openId,
          name: this.formValue.owner,
          phoneNo: this.formValue.phoneNo
        })
        if (response.code === 1000) {
          this.$toast('发送成功，请查收')
        }
        this.counting = true
        clearInterval(this.sendTimer)
        this.sendTimer = setInterval(() => {
          this.countDown = this.countDown - 1
          if (this.countDown === 0) {
            clearInterval(this.sendTimer)
            this.counting = false
            this.countDown = 60
          }
        }, 1000)
      }
    },
    async onSubmitForm() {
      if (!this._validateFormValue()) {
        return
      }
      const openId = localStorage.getItem('openId')
      this.loading = true
      const response = await bindAlliance({
        openId,
        inviteCode: this.inviteCode,
        ...this.formValue
      })
      this.loading = false
      if (response.success) {
        this.$toast({
          message: '注册商户成功，请联系管理人分配权限'
        })
        this.hasBeenAgent = true
      } else {
        this.$toast({
          message: response.message || '注册商户失败，请稍后重试'
        })
        this.formValue.vcode = ''
      }
    },
    _validateFormValue(type = 'submit') {
      const { partnerName, entity, owner, phoneNo, vcode } = this.formValue
      if (!partnerName) {
        this.$toast({
          message: '请填写商户名称'
        })
        return false
      }
      if (!entity) {
        this.$toast({
          message: '请填写商户主体'
        })
        return false
      }
      if (!RegExp.NAME_REG.test(owner)) {
        this.$toast({
          message: '请填写正确的负责人姓名'
        })
        return false
      }
      if (!RegExp.PHONE_REG.test(phoneNo)) {
        this.$toast({
          message: '请填写正确的负责人手机'
        })
        return false
      }
      if (type === 'submit') {
        if (!RegExp.CODE_REG.test(vcode)) {
          this.$toast('请填写正确的短信验证码')
          return false
        }
      }
      return true
    }
  }
}
</script>
<style lang="stylus">
  .be-alliance-container {
    .header {
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      background: #fff;
      border-bottom: 1px solid #eee;
      z-index: 1;
      .icon {
        line-height: 40px;
        position: absolute;
        left: 10px;
      }
    }
    .content {
      font-size: 14px;
      height: 100vh;
      line-height: 40px;
      &.success {
        .van-empty__image {
          width: 100px
          height 120px
          img {
            width 100px
            height 100px
            margin 0 auto
          }
        }
        .van-empty__description {
          padding-left 30px
          padding-right: 30px
          font-size 14px
          .title {
            font-size 16px
            text-align center
            margin-bottom 10px
            color #000
          }
        }
      }
      .code-field {
        padding 5px 16px
        display flex
        align-items center
      }
      .button-container {
        position: fixed
        bottom 0
        left 0
        padding: 20px 10px
        width: 100%
        background: #f7f8fa;
        .van-checkbox {
          justify-content center
          margin-bottom 5px
        }
      }
    }
  }
</style>
